import { createBrowserHistory } from "history";

// Creates And Stores Browser History
export default createBrowserHistory();
